/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import React, { useRef } from "react";
import "../../App.css";
import DataTable from "react-data-table-component";
import axios from "axios";
import { endpoints } from "../../services/apiurl";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { InfinitySpin } from "react-loader-spinner";

class OrderLeads extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      items: [],
      DataisLoaded: false,
      start_date: "",
      end_date: "",
      type: "",
      currentPage: 1,
      totalPages: 1,
      total: "",
      per_page: 10,
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData() {
    let a = localStorage.getItem("user");
    let b = JSON.parse(a);
    let user_id = b.id;
    let restro_id = b.restro_id;
    var page = this.state.currentPage;
    var per_page = this.state.per_page;
    var type = "2";
    axios
      .post(endpoints.getRegistrationData, {
        page,
        per_page,
        user_id,
        restro_id,
        type,
      })
      .then((response) => {
        this.setState({
          items: response.data.data,
          total: response.data.total,
          totalPages: response.data.total_pages,
          DataisLoaded: true,
        });
      });
  }

  render() {
    const { DataisLoaded } = this.state;
    const a = this.state.items;
    const b = this.state.total;
    const dates = new Date();
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const month = months[dates.getMonth()];
    const date = JSON.stringify(dates.getDate());
    const year = JSON.stringify(dates.getFullYear());
    const recent_date = month + "-" + date;

    const columns = [
      {
        name: "Name",
        selector: (row) => row.name,
        cellExport: (row) => row.name,
        sortable: true,
      },
      {
        name: "Email",
        selector: (row) => row.email,
        cellExport: (row) => row.email,
        sortable: true,
      },
      {
        name: "Mobile Number",
        selector: (row) => row.mobilenumber,
        cellExport: (row) => row.mobilenumber,
        sortable: true,
      },
      {
        name: "Product Like",
        selector: (row) => row.product_like,
        cellExport: (row) => row.product_like,
        sortable: true,
      },
      {
        name: "Restaurant",
        selector: (row) => row.rest_name,
        cellExport: (row) => row.rest_name,
        sortable: true,
      },
    ];

    const data = a;
    const tableData = {
      columns,
      data,
    };

    if (!DataisLoaded)
      return (
        <div className="spinner">
          <InfinitySpin
            visible={true}
            width="200"
            color="#fbaa1a"
            ariaLabel="infinity-spin-loading"
          />
        </div>
      );

    return (
      <>
        <h2>Bentchair Order Leads</h2>

        <div className="row mt-5">
          <DataTableExtensions {...tableData}>
            <DataTable
              defaultSortField="id"
              pagination
              paginationPerPage={7}
              paginationRowsPerPageOptions={[7, 14, 21, 28, 35]}
            />
          </DataTableExtensions>
        </div>
      </>
    );
  }
}
export default OrderLeads;
